import { styled } from "@mui/system"
import { Box, TextField } from "@mui/material"
// @ts-ignore
import DoneIcon from "./done.svg?react"
// @ts-ignore
import ErrorIcon from "./error_outline.svg?react"

export const TextboxWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  paddingRight: "8px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
})

export const StyledTextField = styled(TextField)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
}))

export const StyledIcon = styled(Box)(() => ({
  svg: {
    width: "20px",
    height: "20px",
  },
}))

export const StyledStatusIcon = styled(DoneIcon)(() => ({
  stroke: "var(--green-2)", 
  color: "var(--green-2)",
}))

export const StyledErrorIcon = styled(ErrorIcon)(() => ({
  stroke: "var(--cherry)",
  color: "var(--cherry)",
}))
